<template>
  <div class="shop-settings-password">
    <div class="text-h6 mb-3"
      >To update your password, you'll need to follow a special link in an
      email. To receive the link via email click the button below.</div
    >
    <transition name="fade" mode="out-in">
      <v-alert v-if="wasEmailSent" type="success" text
        >Password reset email sent! Please check your inbox.</v-alert
      >
      <SendPasswordResetButton
        v-else
        title="Send Password Link"
        color="blue darken-2 white--text"
        depressed
        :text="false"
        :block="false"
        :email="getAuthUser.email || ''"
        @success="successHandler"
        @error="error = $event"
      />
    </transition>
    <v-alert v-if="!!error" type="error" text class="mt-4">
      {{ error }}
    </v-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SendPasswordResetButton from '@/components/SendPasswordResetButton'

export default {
  name: 'ShopSettingsPassword',
  components: { SendPasswordResetButton },
  data() {
    return {
      showDialog: false,
      wasEmailSent: false,
      error: false,
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopId']),
    ...mapGetters('auth', ['getAuthUser']),
  },
  methods: {
    successHandler() {
      this.wasEmailSent = true
      this.error = null
    }, // successHandler
  },
}
</script>
